<div id="app">
  <app-header></app-header>
  <app-auth *ngIf="authModal"></app-auth>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
